var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { EmploymentType, JobPostingStatus } from "../../model";
import { safeAssign } from "./safe-assign";
import { VenueDTO } from "./venue.dto";
export class JobPostingPublicDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingPublicDTO.prototype, "uuid", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingPublicDTO.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingPublicDTO.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingPublicDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], JobPostingPublicDTO.prototype, "payType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingPublicDTO.prototype, "payAmount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingPublicDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingPublicDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], JobPostingPublicDTO.prototype, "employmentType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], JobPostingPublicDTO.prototype, "hoursPerWeek", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], JobPostingPublicDTO.prototype, "imageUrls", void 0);
__decorate([
    Expose(),
    Type(() => VenueDTO),
    __metadata("design:type", VenueDTO)
], JobPostingPublicDTO.prototype, "venue", void 0);
//# sourceMappingURL=recruiting.jobs.dto.js.map